import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { CauHinhSMSQuyTrinh } from './cau-hinh-sms-quy-trinh';
@Injectable()
export class CauHinhSMSQuyTrinhService {

    controller:string = 'HT_CauHinhSMSQuyTrinh';
    constructor(private http: Http) { }
    
    GetList(IdQuyTrinh:number,IdMucDoUuTien:number,IdBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +this.controller+ "/GetList?idQuyTrinh=" + IdQuyTrinh+"&idMucDoUuTien="+IdMucDoUuTien+"&idBuoc="+IdBuoc, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:CauHinhSMSQuyTrinh) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Delete(item:CauHinhSMSQuyTrinh) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Delete', item, { headers: headers }).map(resp => resp.json());
    }
    getListNhanVienTheoCoQuanQuyTrinhSMS(idCoQuan:number, idDonVi:number, idCauHinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller+ '/GetListNhanVienTheoCoQuanQuyTrinhSMS?idCoQuan=' + idCoQuan + "&idDonVi=" + idDonVi+"&idCauHinh="+idCauHinh, { headers: headers }).map(resp => resp.json());    
    }
    getListNhanVienNhanSMS(idCauHinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ '/GetListNhanVienNhanSMS?idCauHinh='+idCauHinh, { headers: headers }).map(resp => resp.json());    
    }
    addNhanVien(idCuocHop: number, listNhanVien: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ '/addNhanVien?idCauHinh=' + idCuocHop, JSON.stringify(listNhanVien), {
            headers: headers
        }).map(resp => resp.json())
    }

    CapNhatSTT(data:any) {
        let headers = new Headers();
        console.log(data);
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl+ this.controller+ '/CapNhatSTT', JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
    }
    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/cau-hinh-sms-quy-trinh.service.ts